import { states } from './constants';

class StringUtils {
  capitalizeFirstLetter = (string) => {
    return string.replace(/\b\w/g, function (char) {
      return char.toUpperCase();
    });
  };

  getStateByAbbreviation = (abbreviation) => {
    const state = states.find(
      (state) => state.abbreviation === abbreviation
    );
    return state ? state.name : null;
  };

  getAbbreviationByState = (name) => {
    const state = states.find(
      (state) => state.name.toLowerCase() === name.toLowerCase()
    );
    return state ? state.abbreviation : null;
  };
}

export default StringUtils;
